import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import { MemberAuthProvider } from './contexts/MemberAuthContext.jsx';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <MemberAuthProvider>
      <App />
    </MemberAuthProvider>
  </React.StrictMode>
);

// Service worker se NEregistruje (dříve cache-first → bílá obrazovka po deployi).
// Necháme prohlížeč jen zkontrolovat /sw.js (sebezničující skript) u stávajících
// registrací z předchozí verze, aby se odregistroval a vyčistil staré cache.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations()
    .then((regs) => regs.forEach((r) => r.update()))
    .catch(() => {});
}
